import DialogPage from "../DialogPage";
import {useContext, useState} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import Text from "../components/Text";
import Game from "../../../rest/jtmc/models/Game";
import BranchInfo from "../../../rest/jtmc/models/BranchInfo";
import {Image, View} from "react-native";
import {ColumnSpace} from "../components/_CommonComponents";
import Map from "../../../components/custom-components/Map";
import Button from "../components/Button";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";

export default function BranchInfoScreen({route, navigation}: any) {
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const appFunctions = useContext(AppFunctionsContext);

    let {branchInfo}: { branchInfo: BranchInfo } = route.params;

    const contacts = branchInfo.contactNumbers.map(number=>{
        return <Button scheme="regular" onPress={()=>{
            appFunctions.functions.openTellUrl(number.toString());
        }} color={colors.get("primaryColor") as string} title={number.toString()}/>
    });

    return <DialogPage navigation={navigation} header={"اطلاعات شعبه"}>
        <View style={{justifyContent: "center", alignItems: "center"}}>
            <Image source={{uri: branchInfo.storeLogos.logo192}} style={{width: 60, height: 60}}/>
            <ColumnSpace/>
            <Text style={{textAlign: "center"}} color={colors.get("primaryColor") as string} size={14} weight={600}>
                {branchInfo.storeName}
            </Text>
            <Text style={{textAlign: "center"}} color={colors.get("primaryColor") as string} size={12} weight={600}>
                {`شعبه: ${branchInfo.branchName}`}
            </Text>
            <ColumnSpace/>
            <Map function={"overview"} defaultLocation={branchInfo.branchLocation} width={"100%"} height={150}/>
            <ColumnSpace/>
            {contacts.length == 0 ? <></> : <View>
                <Text style={{textAlign: "center"}} color={colors.get("highConText") as string} size={14} weight={600}>
                    شماره تماس شعبه:
                </Text>
                {contacts}
            </View>}
        </View>
    </DialogPage>
}
